/**
 * Endpoints whose requests must never be re-sent automatically.
 *
 * When a request fails at the network layer, BaseApiService stores it so the trouble and
 * maintenance pages can offer a "Try Again" button. That is safe for a read, and unsafe for a
 * charge: a connection that drops after the server has already reached Stripe looks identical to
 * one that never arrived, so replaying the stored POST bills the customer a second time.
 *
 * Anything that moves money or creates an account belongs on this list.
 */
export const NON_REPLAYABLE_URL_FRAGMENTS = [
    '/v1/payments/',
    '/v1/continuing-education/purchase',
    '/v1/signup/',
];

/**
 * True when a failed request is safe to re-send without the user re-initiating it.
 *
 * @param url - The request URL, absolute or relative
 */
export function isReplayableRequest(url: string): boolean {
    if (!url) return false;
    const lowered = url.toLowerCase();
    return !NON_REPLAYABLE_URL_FRAGMENTS.some((fragment) => lowered.includes(fragment));
}
